import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-forest text-cream py-24 px-6 relative overflow-hidden" data-id="element-72">
      {/* Subtle background pattern/texture could go here */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-cream to-transparent pointer-events-none" data-id="element-73"></div>

      <div className="max-w-[900px] mx-auto relative z-10" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="space-y-10" data-id="element-75">
          <div className="border-l-4 border-accent pl-6 md:pl-10 py-2" data-id="element-76">
            <p className="font-serif text-2xl md:text-3xl lg:text-4xl leading-relaxed font-medium" data-id="element-77">
              Votre ticket de caisse vous donne le vertige ? Payer{' '}
              <span className="text-accent font-bold" data-id="element-78">5$</span> pour un bouquet
              de basilic qui fane en 48h ou{' '}
              <span className="text-accent font-bold" data-id="element-79">4$</span> pour une laitue
              pleine de pesticides n'est plus une option. <br data-id="element-80" />
              <br data-id="element-81" />
              <span className="italic text-cream/80" data-id="element-82">
                C'est une taxe sur votre survie.
              </span>
            </p>
          </div>

          <div className="space-y-6 font-sans text-lg md:text-xl text-cream/90 leading-relaxed max-w-3xl ml-auto" data-id="element-83">
            <p data-id="element-84">
              La plupart des gens pensent qu'il faut un grand jardin en campagne
              pour manger frais et local.{' '}
              <strong className="text-accent" data-id="element-85">C'est faux.</strong>
            </p>
            <p data-id="element-86">
              Pendant que vous lisez ces lignes, des milliers de citadins à
              Montréal, Paris et Lyon transforment leurs petits appartements en
              systèmes de production ultra-rentables.
            </p>
            <p className="font-serif text-2xl text-white pt-4" data-id="element-87">
              Ils ne jardinent pas pour le plaisir...{' '}
              <span className="underline decoration-accent decoration-2 underline-offset-4" data-id="element-88">
                ils produisent pour l'indépendance.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}